import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionStorage, LocalStorage } from 'ngx-webstorage';
import { AppCommonService } from '../app-common.service';
import { Auth, Login, UpdateSession } from './login';
import { SharedService } from 'src/app/utils/services/shared.service';
import { MatSnackBar } from '@angular/material/snack-bar';

// declare let $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'amazon-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
  @SessionStorage('auth') public authToken: Auth = new Auth();
  @LocalStorage('auth') public authTokn: Auth = new Auth();
  @SessionStorage('moduleRoles') public myModules: any;
  @SessionStorage('region') public region;
  public encryptInfo;
  public login: Login = new Login();
  public sessionObj: UpdateSession = new UpdateSession();
  public loader = false;
  public showPassword = false;

  constructor(
    private router: Router,
    private commonService: AppCommonService,
    private snackBar: MatSnackBar,
    private sharedService: SharedService
  ) { }

  ngOnInit() {
    sessionStorage.clear();
  }

  onSubmit() {
    this.sharedService.display(true);
    this.commonService.login('login', this.login).subscribe((response) => {
      if (response.success) {
        this.authToken = new Auth(response.payload);
        this.authTokn = new Auth(response.payload);
        this.createSession();
        this.region = response.payload.user.region;
        this.sharedService.display(false);
      } else {
        this.sharedService.display(false);
        this.snackBar.open((response.error && response.error.message ? response.error.message : window['serverError']), 'okay', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
      }
    }, (error) => {
      this.sharedService.display(false);
      if (error.error) {
		  
        this.snackBar.open((error.error.message ? error.error.message : window['serverError']), 'okay', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
      } else {
        this.snackBar.open('Server Down', 'okay', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
      }
    })
  }

  /* update the session */
  createSession() {
    this.sessionObj.token = this.authToken.token;
    this.sessionObj.type = this.authToken.tokenType;
    this.sessionObj.userid = this.authToken.userDetails.userid;
    this.updateSession();
  }

  updateSession() {
    this.commonService.update('session/log', this.sessionObj).subscribe((response) => {
      if (response.success) {
        this.getModuleRoute();
      } else {
        this.snackBar.open(response.error.message, 'okay', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
      }
    }, (error) => {
      this.snackBar.open(error.error.message, 'okay', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
    })
  }

  /* get route */
  getModuleRoute() {
    this.commonService.login('user/getUserModules', {}).subscribe((response) => {
      const self = this;
      if (response.success && response.payload) {
        this.myModules = response.payload;
        response.payload.every(function (element) {
          switch (element.modulename) {
            case 'Dashboard':
              self.router.navigate(['/dashboard']);
              break;
            default:
              break;
          }
          return false;
        });
      } else {
        this.snackBar.open(response.error.message, 'okay', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
      }
    }, (error) => {
      this.snackBar.open(error.error.message, 'okay', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
    })
  }

  /* toggle password */
  toggleInputType() {
    this.showPassword = !this.showPassword;
  }

}
